import { Box, useTheme } from '@mui/material';
import { Suspense } from 'react';
import { Outlet } from 'react-router';

import { Loader } from '@/modules/common/components';
import PublicFooter from '@/modules/data-management/components/PublicFooter/PublicFooter';

const PublicLayout = () => {
  const theme = useTheme();
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
      }}
    >
      <Box
        component="main"
        sx={{
          position: 'relative',
          overflow: 'hidden',
          flexGrow: 1,
          minHeight: '100vh',
          padding: theme.spacing(0, 3, 3, 0),
        }}
      >
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
        <PublicFooter />
      </Box>
    </Box>
  );
};

export default PublicLayout;
